(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var select = document.getElementById('ContactForm-customer-type');
    var wrapper = document.getElementById('ContactForm-store-name-wrapper');
    var storeInput = document.getElementById('ContactForm-store-name');

    if (!select || !wrapper || !storeInput) return;

    function toggleStoreField() {
      var isWholesale = select.value === 'Wholesale';

      if (isWholesale) {
        wrapper.removeAttribute('hidden');
        storeInput.setAttribute('required', 'required');
        storeInput.setAttribute('aria-required', 'true');
      } else {
        wrapper.setAttribute('hidden', '');
        storeInput.removeAttribute('required');
        storeInput.removeAttribute('aria-required');
        storeInput.value = '';
      }
    }

    select.addEventListener('change', toggleStoreField);

    // Run on load in case of back-navigation with preserved form state
    toggleStoreField();
  })();
  } catch(e) { console.error(e); }
})();

})();
